import * as React from 'react';
import Loader from '../components/Loader';
import NotFound from './NotFound';
import EditShippingMethod from './EditShippingMethod';
import { useRequest, getHeaders } from '../api/client';
import { ProfileContext, ProfileManager } from '../profile';
import { RouteComponentProps } from 'react-router';

const shippingMethod = (id: string, context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: `/store/shippig-methods/${id}`,
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

const getStateEntity = (props: RouteComponentProps<any>) => {
  return props.location.state ? props.location.state.method : null;
};

const getEntityID = (props: RouteComponentProps<any>) => {
  return props.match.params.id;
};

export function withState(Component: any) {
  return (props: RouteComponentProps<any>) => {
    const context = React.useContext(ProfileContext);
    const preloadedEntity = getStateEntity(props);

    if (preloadedEntity) {
      return <Component method={preloadedEntity} />;
    }

    const state = shippingMethod(getEntityID(props), context);

    if (state.loading || !state.data) {
      return <Loader />;
    }

    if (state.error) {
      return <NotFound />;
    }

    return <Component method={state.data} />;
  };
}

export default withState(EditShippingMethod);
